import axiosBase from "@/api/axiosBase";

const state = {

}

const mutations = {

}

const actions = {
  // 模型外部数据-获取所有的数据
  getExtAllData({ commit }, data) {
    return new Promise((resolve) => {
      axiosBase({
        method: 'POST',
        url: '/model/extdata/find_all',
        data: {
          "model_id": data.modelId,
          "data_type": data.type
        }
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 模型外部数据-获取所有的元数据
  getExtAllMetaData({ commit }, data) {
    return new Promise((resolve) => {
      axiosBase({
        method: 'POST',
        url: '/model/extdata/list_meta',
        data: {
          "model_id": data.modelId,
          "data_type": data.type
        }
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 模型外部数据-获取所有数据的id
  getExtAllIdData({ commit }, data) {
    return new Promise((resolve) => {
      axiosBase({
        method: 'POST',
        url: '/model/extdata/list_id',
        data: {
          "model_id": data.modelId,
          "data_type": data.type
        }
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 模型外部数据-获取数据值
  getExtValue({ commit }, data) {
    return new Promise((resolve) => {
      axiosBase({
        method: 'POST',
        url: '/model/extdata/get_value',
        data: {
          "data_id": data.dataId,
          "model_id": data.modelId,
          "data_type": data.type
        }
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 模型配置比较(air, ptsrc, withdraw, decay, irrig, accum, restart)
  modelConfigCompare(context, data) {
    void context;
    return axiosBase({
      method: 'POST',
      url: '/model/compare/model_compare_config',
      data: {
        "model_ids": data.modelIds,
        "result_type": data.resultType
      }
    })
  },

  // 模型结果比较
  modelResultCompare(context, data) {
    void context;
    return axiosBase({
      method: "POST",
      url: "/model/compare/model_compare",
      data: {
        model_ids: data.modelIds,
        result_type: data.resultType,
      },
    });
  },

  // 流域出口结果比较
  basinOutletCompare(context, data) {
    void context;
    return axiosBase({
      method: "POST",
      url: "/model/compare/basinOutletCompare",
      data: {
        model_ids: data.modelIds,
        vars: data.vars,
      },
    });
  },

  // 流域出口年度序列
  basinOutletYearSeries(context, data) {
    void context;
    return axiosBase({
      method: "POST",
      url: "/model_result/basinOutletYearSeries",
      data: {
        model_ids: data.modelIds,
        rch_name: data.rchName,
        var: data.var,
      },
    });
  },

  //获取统计结果
  getOverview(context, data) {
    void context;
    return axiosBase({
      method: "POST",
      url: "/model_result/overview",
      data: {
        model_id: data.sceneId,
        obj_type: data.type,
        scale: data.scale,
      },
    });
  },



  // 模型结果比较_landuse
  modelResultCompare_landuse(context, data) {
    void context;
    return axiosBase({
      method: "POST",
      url: "/model/compare/model_compare_landuse",
      data: {
        model_ids: data.modelIds,
      },
    });
  },

  // 获取时间序列
  getTimeSeries({ commit }, data) {
    return new Promise((resolve) => {
      axiosBase({
        method: 'POST',
        url: '/model_result/other_timeseries',
        data: {
          "id": data.id,
          "model_id": data.modelId,
          "obj_type": data.objType,
          "var": data.var
        }
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取Landuse时间序列
  getLanduseTimeSeries({ commit }, data) {
    return new Promise((resolve) => {
      axiosBase({
        method: 'POST',
        url: '/model_result/landuse_timeseries',
        data: {
          "deluid": data.deluid,  // hru编号
          "model_id": data.modelId,
          "subbasin": data.subbasin, // 子流域/子河道
          "var": data.var
        }
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

}

const getters = {
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
